export const HOME_PATH = '/';
export const IMAGE_LABELS_PATH = '/image-labels';
export const LEMONADE_PATH = '/lemonade';
export const LEMONADE_EDITOR_TYPE_PATH = '/lemonade-editor/:type';
export const LEMONADE_EDITOR__PATH = '/lemonade-editor';
export const GENERATOR_PATH = '/generator';
export const SCAFFOLD_EXAMPLE_PATH = '/scaffold-example';
export const SCAFFOLD_MOBILE_CUSTOM_PATH = '/scaffold-mobile-custom';
export const SCAFFOLD_VIEWER_PATH = '/scaffold-viewer';
export const SCAFFOLD_MOBILE_VIEWER_PATH = '/scaffold-mobile-viewer';
export const QUESTION_VIEWER_PATH = '/question-viewer';
export const LEMONADE_ACTIVITY_PREVIEW_PATH = '/lemonade-activity-preview';
export const STYLE_GUIDE_PATH = '/style-guide';
export const PLAYGROUND_MATH_PATH = '/playground-math';
export const ALL_QUESTIONS_PATH = '/questions';
export const ALL_EDITORS_PATH = '/editors';
export const CLOCK_PATH = '/clock';
export const VIDEOLESSON_PATH = '/videolesson';
export const MINT_PATH = '/mint';
export const MINT_COURSE_PATH = '/course';
export const AI_PATH = '/ai';
export const VIDEO_RECORDER_PATH = '/video-recorder';
export const KC_PLAYGROUND_PATH = '/ai/kc-playground';
export const ACTIVITIES_PLAYGROUND_PATH = '/ai/activities-playground';
export const KC_ORCHESTRATOR_PATH = '/ai/kc-orchestrator';
